import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class PaymentModeDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "States id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "States Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Payment Mode id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  paymentModeId?: number;
  @ApiProperty()
  @MaxLength(15, { message: "Payment Mode allows maximum 15 characters" })
  @IsNotEmpty()
  paymentMode: string;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

